<template>

  <div v-if="systemError" id="systemUpdate">
    <h1>

      <img src="./assets/gfx/logofull.png" id="logo" style="width: 230px; display: block; margin: 0 auto 1rem;"
        alt="EZtrade" />
      System maintenance
    </h1>


    <p style="direction: ltr">
      Our servers are currently undergoing maintenance due to unexpected issue with our hosting providers. <br />We will
      be back up and running as
      soon as possible.
      <br />Thank you for your patience.
    </p>
  </div>

  <div v-else>
    <div v-if="!userPingged">
      <LockView v-if="locked" />
      <PremiumLockView :trial-ended="trialEnded" :user="trialEndedUser" :showPremiumLogin="showPremiumLogin"
        v-if="prmLock" />
    </div>
    <div id="appWrapper" :theme="systemTheme" v-else>


      <Toast :message="appToastMessage" ref="appToastMessage" />

      <div v-if="!acceptedTerms">
        <Terms @accepted="acceptedTermsInit()" :terms="termsContent" />
      </div>
      <div v-if="acceptedTerms && dictionary.navBar" :key="globalKey" id="mainWrapper">

        <BetaOverNotification :user="trialEndedUser" />
        <OverlayUI @close="isFirstLogin = false" v-if="isFirstLogin">
          <div class="banner bottom systemLanguage">
            <FirstLoginInstructions @close="isFirstLogin = false" />
          </div>
        </OverlayUI>

        <keep-alive>
          <SearchBar @close="showSearchBar = false" v-if="showSearchBar" />
        </keep-alive>

        <ContactUs v-if="showContactUs" @close="showContactUs = false;" @sent="contactUsSent" />

        <div id="contactUsSent" style="display: none;" class="hide" ref="thankYou">
          <span>{{ dictionary.messages.contactMessageSentTitle }}</span>
          <br />
          {{ dictionary.messages.contactUsThankYou }}
        </div>

        <Transition name="slide-fade">

          <nav id="mobileNavBar" v-if="showMobileSideBar">
            <div class="navLink closeLink" @click="showMobileSideBar = false">
              <i class="ri-close-line" style="font-size: 22px" />
            </div>

            <router-link to="/movers" class="navLink" @click="showMobileSideBar = false; clickEvent('home')"><i
                class="ri-arrow-left-right-line" />
              {{ dictionary.navBar.movers }}
            </router-link>
            <router-link to="/signals" class="navLink" @click="showMobileSideBar = false; clickEvent('home')"><i
                class="ri-rfid-line" />
              {{ dictionary.navBar.signals }}
            </router-link>
            <router-link to="/feed" class="navLink" @click="showMobileSideBar = false; clickEvent('feed news')"><i
                class="ri-newspaper-line" />
              {{ dictionary.navBar.stocksFeed }}
            </router-link>
            <!--            <router-link to="/macro" class="navLink" @click="showMobileSideBar = false; clickEvent('macro news')"><i-->
            <!--                class="ri-global-line"/>-->
            <!--              {{ dictionary.navBar.macroFeed }}-->
            <!--            </router-link>-->

            <router-link to="/watchlist" class="navLink" @click="showMobileSideBar = false; clickEvent('watchlist')"><i
                class="ri-folder-line" />
              {{ dictionary.navBar.myWatchlist }}
            </router-link>


            <!--            <router-link to="/indices" class="navLink" @click="showMobileSideBar = false; clickEvent('indices')"-->
            <!--            >-->
            <!--              <i-->
            <!--                  class="ri-global-line"/>-->
            <!--              <span>-->
            <!--                {{ dictionary.navBar.indices }}-->
            <!--              </span>-->
            <!--            </router-link>-->
            <router-link to="/calendars" class="navLink" @click="showMobileSideBar = false; clickEvent('calendars')"><i
                class="ri-calendar-line" />
              {{ dictionary.navBar.calendars }}
            </router-link>

            <router-link to="/sectors" class="navLink" @click="showMobileSideBar = false; clickEvent('sectors')"><i
                class="ri-donut-chart-line" />
              {{ dictionary.navBar.sectors }}
            </router-link>

            <router-link to="/indices" class="navLink" @click="showMobileSideBar = false; clickEvent('indices')"><i
                class="ri-global-line" />
              {{ dictionary.navBar.indices }}
            </router-link>

            <router-link to="/social" class="navLink" @click="showMobileSideBar = false; clickEvent('social trend')"><i
                class="ri-group-line" />
              {{ dictionary.navBar.socialBuzz }}
            </router-link>


            <!--            <router-link to="/topro" class="navLink" @click="showMobileSideBar = false; clickEvent('top10Pro')">-->
            <!--              <i-->
            <!--                  class="ri-medal-2-line"/>-->
            <!--              <span>-->
            <!--                {{ dictionary.navBar.top10Pro }}-->
            <!--              </span>-->

            <!--            </router-link>-->

            <router-link to="/settings" class="navLink" @click="showMobileSideBar = false; clickEvent('settings')"><i
                class="ri-settings-3-line" />
              {{ dictionary.navBar.settings }}
            </router-link>


            <!--            <div class="navLink contactButton" @click="showContactUs = true">-->
            <!--            <i class="ri-mail-line"/>-->
            <!--              {{ dictionary.navBar.contactUs }}-->
            <!--            </div>-->

            <!--            <div class="navLink terms" @click="acceptedTerms = false; clickEvent('read terms')">-->
            <!--              {{ dictionary.navBar.termsOfUse }}-->
            <!--            </div>-->

          </nav>
        </Transition>

        <nav id="navBar" class="p" @mouseenter="hoverMenu = true" :dir="uiDirection" @mouseleave="hoverMenu = false"
          :class="{ menuOn: hoverMenu }">

          <div class="navLinks">

            <a href="javascript: void(0)" class="navLink desktop" @click="showSearchBar = true">
              <i class="ri-search-line" />
              <span>{{ dictionary.symbolSearch.inputLabel }}</span>
            </a>

            <div class="mobile" id="mobileMenu" :class="{ whiteMobilMenu: locationIncludes('ibi.') }">
              <div id="proMobileMenu">
                <i class="ri-menu-line" style="margin: -15px; padding: 15px;"
                  @click="showMobileSideBar = !showMobileSideBar" />

                <div id="searchSymbolButton" @click="showSearchBar = true">
                  <i class="ri-search-line" />
                  {{ dictionary.symbolSearch.inputLabel }}
                </div>
              </div>

            </div>
            <img :src="setLogo()" id="logo" :style="setLogoWidth()" style="max-height: 34px;" v-if="logoSrc" />



          </div>


          <div id="desktopLinks">
            <router-link to="/" class="navLink desktop" @click="clickEvent('home')">
              <i class="ri-arrow-left-right-line" />
              <span>{{ dictionary.navBar.movers }}</span>
            </router-link>

            <router-link to="/signals" class="navLink desktop" @click="clickEvent('home')">
              <i class="ri-rfid-line" />
              <span>{{ dictionary.navBar.signals }}</span>
            </router-link>

            <router-link to="/watchlist" class="navLink desktop" @click="clickEvent('watchlist')">
              <i class="ri-folder-line" />
              <span>{{ dictionary.navBar.myWatchlist }}</span>
            </router-link>


            <a href="#" class="navLink desktop breakingNewsItem" @click="showBreakingFeed = true">
              <i class="ri-fire-line" />
              <span>{{ dictionary.feeds.breakingNews }}</span>
            </a>

            <!--          <router-link to="/macro" class="navLink desktop" @click="clickEvent('macro news')"><i-->
            <!--              class="ri-global-line"/>-->
            <!--            <span>{{ dictionary.navBar.macroFeed }}</span>-->
            <!--          </router-link>-->


            <router-link to="/calendars" class="navLink desktop" @click="clickEvent('calendars')"><i
                class="ri-calendar-line" />
              <span>{{ dictionary.navBar.calendars }}</span>
            </router-link>
            <router-link to="/sectors" class="navLink desktop" @click="clickEvent('sectors')"><i
                class="ri-donut-chart-line" />
              <span>{{ dictionary.navBar.sectors }}</span>
            </router-link>

            <router-link to="/indices" class="navLink desktop" @click="clickEvent('indices')"><i
                class="ri-global-line" />
              <span>{{ dictionary.navBar.indices }}</span>
            </router-link>


            <router-link to="/social" class="navLink desktop" @click="clickEvent('social trend')"><i
                class="ri-group-line" />
              <span>{{ dictionary.navBar.socialBuzz }}</span>
            </router-link>
          </div>

          <div class="navLinks" style="padding: 0 1rem; margin-top: 2px">
            <router-link to="/settings" class="navLink desktop" @click="clickEvent('settings')"><i
                class="ri-settings-3-line" />
              <span>{{ dictionary.navBar.settings }}</span>
            </router-link>


            <a href="javascript: void(0)" class="navLink contactButton desktop" @click="showContactUs = true">
              <i class="ri-mail-line" />
              <span>{{ dictionary.navBar.contactUs }}</span>
            </a>

          </div>

        </nav>


        <main class="feed p" :dir="uiDirection" :class="{ feedMenuOn: hoverMenu }">

          <div class="resizable" :style="{ width: `${resizeable}px !important` }" style="position: relative">
            <div class="dynamicContent">
              <div id="view" @scroll="handleScroll" class="p" ref="scrollContainer">

                <audio ref="alertSound" preload="auto" volume="0.5" id="bloop" controls
                  style="position: absolute; visibility: hidden; left: -9999999px;">
                  <source src="./assets/bell.mp3" type="audio/mpeg" />
                </audio>
                <audio ref="breakingAlertSound" preload="auto" volume="0.5" id="bell" controls
                  style="position: absolute; visibility: hidden; left: -9999999px;">
                  <source src="./assets/boop.mp3" type="audio/mpeg" />
                </audio>


                <EmptyPortfolio v-if="watchlist && watchlist.watchlist && watchlist?.watchlist.length === 0" />
                <Feed key="appFeed" ref="appFeed"
                   :show-filters="true"
                  :feedVisible="feedVisible" :aggregate="true" :type="'neutral'" :is-breaking-open="showBreakingFeed"
                  :is-wiim-open="showWiimFeed" :symbols="feedSymbols" :prices="prices.prices"
                  @showWiim="showWiimFeed = true" @showBreaking="showBreakingFeed = true" @feedLoaded="feedLoaded" />


              </div>
            </div>
          </div>

          <div class="toggleResize hideMobile" @click="toggleFeedVisibility()">
            <div id="feedToggle">
              <i v-if="feedVisible && uiDirection === 'ltr'" class="ri-arrow-left-s-line" />
              <i v-if="!feedVisible && uiDirection === 'ltr'" class="ri-arrow-right-s-line" />

              <i v-if="!feedVisible && uiDirection === 'rtl'" class="ri-arrow-left-s-line" />
              <i v-if="feedVisible && uiDirection === 'rtl'" class="ri-arrow-right-s-line" />
            </div>
          </div>


          <div id="macroNewsFeed" class="p" ref="mainViewContainer" @scroll="handleScrollMainContainer">
            <div class="view">
              <router-view v-slot="{ Component }" :ref="refName" @feedLoaded="feedLoaded"
                @joinFilteredFeed="joinFilteredFeed" :userWatchlistList="watchlist?.watchlist || []"
                @toggleNotifications="toggleNotifications" :type="feedType" :symbols="feedSymbols"
                :notificationsEnabled="notificationsEnabled" :notificationsAvailable="notificationsAvailable"
                :show-filters="$route.name !== 'Macro'" :prices="prices.prices" :key="$route.fullPath" name="Side">

                <keep-alive>
                  <component :is="Component" />
                </keep-alive>
              </router-view>
            </div>

          </div>
        </main>
      </div>
    </div>

    <Window v-if="chartWindowSymbols.length > 0" @close="chartWindowSymbols = []; chartWindowDisplay = null"
      :tabSymbols="chartWindowSymbols" @addWSymbolToTabs="addSymbolsToTab('chartWindowSymbols', $event)"
      key="chartWindow">

      <template #default="{ showSymbolSearchInput }">
        <div class="symbolsQuickViewTabs">
          <div v-for="(symbol, symbolIndex) in chartWindowSymbols" :class="{ active: chartWindowDisplay === symbol }"
            class="quickViewSymbol" :key="`cqv-${symbol}`">
            <i class="ri-close-line" @click="closeChartWindow(symbol)" />
            <div @click="chartWindowDisplay = symbol">{{ symbol }}</div>
          </div>
          <div class="quickViewSymbol">
            <i class="ri-add-large-line" @click="showSymbolSearchInput()" />
          </div>
        </div>
        <keep-alive>
          <TradingViewChart :key="`cqvtv-${chartWindowDisplay}`" :symbol="chartWindowDisplay" />
        </keep-alive>
      </template>

    </Window>
    <Window :hide="minimized.includes('symbolQuickView')" key="symbolQuickView" :tabSymbols="quickViewSymbols"
      @addWSymbolToTabs="addSymbolsToTab('quickViewSymbols', $event)"
      @close="changeableContent = false; quickViewSymbols = [];" @minimize="minimized.push('symbolQuickView')"
      v-if="changeableContent">

      <template #default="{ showSymbolSearchInput }">
        <div class="symbolsQuickViewTabs">
          <div v-for="(symbol) in quickViewSymbols" :class="{ active: quickViewSymbolDisplay === symbol }"
            class="quickViewSymbol" :key="`qv-${symbol}`">
            <i class="ri-close-line" @click="closeQuickViewSymbol(symbol)" />
            <div @click="quickViewSymbolDisplay = symbol">{{ symbol }}</div>
          </div>

          <div class="quickViewSymbol">
            <i class="ri-add-large-line" @click="showSymbolSearchInput()" />
          </div>
        </div>

        <keep-alive>
          <symbol-view v-if="changeableContentSettings.type === 'symbolPreview'" :prices="prices"
            :previewSymbol="quickViewSymbolDisplay" :aggregate="true" :key="quickViewSymbolDisplay + ':p'"
            :isPreview="false" />
        </keep-alive>
        <TradeView v-if="changeableContentSettings.type === 'tradeView'" :tradeId="changeableContentSettings.tradeId" />
      </template>

    </Window>
    <Window type="breaking" key="breakingWindow" :refName="'breakingFeed'" :bodyRef="bodyRef.breakingFeed"
      v-if="showBreakingFeed" @getRef="getRef" @close="showBreakingFeed = false" :title="dictionary.feeds.breakingNews">
      <Feed key="breakingFeed" ref="breakingFeed" :type="'breaking'" :aggregate="false" :in-floating-window="true"
        :show-filters="false" @hideBreaking="showBreakingFeed = false" @feedLoaded="feedLoaded" />
    </Window>

    <Window type="wiim" key="wiimWindow" v-if="showWiimFeed" @close="showWiimFeed = false" :refName="'wiimFeed'"
      @getRef="getRef" :bodyRef="bodyRef.wiimFeed" :title="dictionary.feeds.wiim">
      <Feed key="wiimFeed" :type="'wiim'" :in-floating-window="true" :show-filters="false" :aggregate="false"
        ref="wiimFeed" @hideBreaking="showWiimFeed = false" @feedLoaded="feedLoaded" />
    </Window>

    <Window key="readView" v-if="notificationLink" @close="notificationLink = null;">
      <ReadView :link="notificationLink" />
    </Window>

    <SymbolsList v-if="floatingSymbolsList" :endpoint="floatingSymbolsList.endpoint" :key="floatingSymbolsList.endpoint"
      :list-title="floatingSymbolsList.title" :isFloating="true" @close="floatingSymbolsList = null" />

  </div>

</template>

<script>
import He from "./dictionary/he";

import { computed, getCurrentInstance } from "vue";
import { useEquityPrices } from "./stores/equityPrices";
import { useNewYorkTime } from "./stores/newYorkTime";
import { useWatchlist } from "./stores/watchlist";

// import Socket from './services/socket';
import Socket from './services/ws';
import eventBus from './services/events';
import SymbolsSearch from "./components/ui/SymbolsSearch";
import UserService from './services/user';
import mixpanel from 'mixpanel-browser';


import { useWebNotification, useWindowFocus } from '@vueuse/core'
import Terms from "./components/ui/Terms";
import ContactUs from "./components/ui/ContactUs";
import SearchBar from "./components/ui/SearchBar";
import EmptyPortfolio from "./components/ui/EmptyPortfolio";
import Toast from "./components/ui/Toast";
import OverlayUI from "./components/ui/Overlay";
import MBPButton from "./components/ui/controls/MBPButton";
import ToggleSwitch from "./components/ui/ToggleSwitch";
import BetaOverNotification from "./components/sysNotifications/BetaOverNotification";
import FirstLoginInstructions from "./components/sysNotifications/FirstLoginInstructions";
import Window from "./components/ui/Window";

import Feed from "./views/FeedView";
import LockView from "./views/LockView";
import PremiumLockView from "./views/PremiumLockView";
import SymbolView from "./views/SymbolView";
import TrialEnded from "./views/settingsView/TrialEnded";
import SectorAssetsList from "./views/sectorMoneyFlow/SectorAssetsList";
import TradeView from "./views/TradeView";
import ReadView from "./views/ReadView";
import TradingViewChart from "./components/charts/TradingView";
import SymbolsList from "./views/SymbolsList";


import { useInteractionBasedReload } from "./composables/userInteractionBasedReload";

export default {
  name: 'Home',
  components: {
    SymbolsList,
    TradingViewChart,
    Window,
    ReadView,
    TradeView,
    SectorAssetsList,
    FirstLoginInstructions,
    ToggleSwitch,
    MBPButton,
    OverlayUI,
    TrialEnded,
    BetaOverNotification,
    He,
    SymbolView,
    Toast,
    PremiumLockView, SearchBar, LockView, EmptyPortfolio, ContactUs, Terms, SymbolsSearch, Feed
  },
  data() {
    return {
      bodyRef: {
        breakingFeed: null,
        wiimFeed: null
      },
      soundsOn: true,
      floatingSymbolsList: null,
      minimized: [],
      chartWindowSymbols: [],
      chartWindowDisplay: null,
      feedVisible: true,
      notificationLink: null,
      showBreakingFeed: false,
      showWiimFeed: false,
      changeableContentKey: 0,
      betaUser: false,
      resizeable: 420,
      systemTheme: 'darkMode',
      isFirstLogin: false,
      isAffiliate: false,
      changeableContentSettings: {},
      quickViewSymbols: [],
      quickViewSymbolDisplay: null,
      changeableContent: false,
      width: window.innerWidth * 0.3,
      changeableContentWidth: window.innerWidth <= 660 ? '100%' : window.innerWidth * 0.33,
      resizing: false,
      appToastMessage: null,
      showPremiumLogin: false,
      trialEnded: false,
      trialEndedUser: null,
      showSearchBar: false,
      hoverMenu: false,
      locked: false,
      prmLock: true,
      termsContent: null,
      showLanguageMenu: false,
      globalKey: 1,
      systemError: false,
      notificationsEnabled: false,
      notificationsAvailable: false,
      showContactUs: false,
      logoSrc: null,
      showMobileSideBar: false,
      userPingged: false,
      acceptedTerms: false,
      socket: null,
      symbolsInView: [],
      storedWatchlist: [],
      watchlist: useWatchlist(),
      refName: 'mainView',
      feedType: 'neutral',
      feedSymbols: []
    }
  },
  setup() {
    const prices = useEquityPrices();
    const app = getCurrentInstance();
    const isTabFocused = useWindowFocus()
    document.documentElement.style.setProperty('--dir', 'rtl');
    document.body.classList.add('rtl')

    const {
      getFormattedTimeSince,
      resetInteractionTimer
    } = useInteractionBasedReload(2);

    const resetTimer = () => {
      resetInteractionTimer()
    }

    return { prices, isTabFocused };
  },
  watch: {
    'socket.isConnected'(current, prev) {

      if (!current) {
        // this.socket.reconnect();
      }
    },
    isTabFocused(current, prev) {

      if (current === true && !this.socket.isConnected) {
        // this.socket.reconnect();
      }
    },
    $route(current, prev) {

      this.changeableContent = false;


      // if (current.name === 'Trades' || current.name === 'SectorFlowTable') {
      //
      //   this.resizeable = 10;
      // } else {
      //   this.resizeable = 520;
      // }

      if (current.name === 'Macro') {

        this.refName = 'newsFeed';
        this.feedType = 'news'

      } else if (current.name === 'Macro') {
        this.refName = 'appFeed';
        this.feedType = 'equity';

      } else if (current.name === 'SectorFeed') {
        this.refName = 'newsFeed';
        this.feedType = 'sector';

      } else if (current.name === 'FilteredFeed') {
        this.refName = 'mainView';
        this.feedType = 'filteredFeed';
      } else {
        this.refName = 'mainView';
        this.feedType = 'neutral'
      }
    }
  },
  methods: {
    toggleSounds() {
      this.soundsOn = !this.soundsOn;
      localStorage.setItem('soundsOn', this.soundsOn);
    },
    getRef(ref) {
      this.bodyRef[ref] = this.$refs[ref];
    },
    addSymbolsToTab(array, symbol) {

      if (!this[array]?.includes(symbol)) this[array].push(symbol);
    },
    openFloatingSymbolsList(settings) {

      this.floatingSymbolsList = { endpoint: settings.endpoint, title: settings.title }
    },
    openChartWindow(symbol) {

      if (!this.chartWindowSymbols.includes(symbol)) {

        this.chartWindowSymbols.push(symbol);
        this.chartWindowDisplay = symbol;
      }
    },
    openMinimized(tab) {

      const index = this.minimized.indexOf(tab);
      this.minimized.splice(index, 1);
    },
    toggleFeedVisibility() {

      this.feedVisible = !this.feedVisible;
      if (!this.feedVisible) {
        this.resizeable = 0;
      } else {
        this.resizeable = 520;
      }
    },
    closeChartWindow(symbol) {

      const symbolIndex = this.quickViewSymbols.indexOf(symbol);
      const newSymbolToDisplay = this.chartWindowSymbols[symbolIndex - 1] ? this.chartWindowSymbols[symbolIndex - 1] : this.chartWindowSymbols[symbolIndex + 1];

      this.chartWindowSymbols.splice(symbolIndex, 1);

      if (this.chartWindowSymbols.length === 0) {
        this.chartWindowDisplay = null;
      } else {

        if (this.quickViewSymbolDisplay === symbol) {
          this.chartWindowDisplay = newSymbolToDisplay;
        }
      }
    },
    closeQuickViewSymbol(symbol) {

      const symbolIndex = this.quickViewSymbols.indexOf(symbol);
      const newSymbolToDisplay = this.quickViewSymbols[symbolIndex - 1] ? this.quickViewSymbols[symbolIndex - 1] : this.quickViewSymbols[symbolIndex + 1];

      this.quickViewSymbols.splice(symbolIndex, 1);

      if (this.quickViewSymbols.length === 0) {
        this.quickViewSymbolDisplay = null;
        this.changeableContent = false;
      } else {

        if (this.quickViewSymbolDisplay === symbol) {
          this.changeableContentSettings.symbol = newSymbolToDisplay;
          this.quickViewSymbolDisplay = newSymbolToDisplay;
        }
      }
    },
    openFeedWindow(feedType) {

      if (feedType === 'breaking') {
        this.showBreakingFeed = true;
      } else if (feedType === 'wiim') {
        this.showWiimFeed = true;
      }
    },
    readNotification(link) {
      this.notificationLink = link;
    },
    handleHashChange() {
      const newHash = window.location.hash;
      if (newHash.toString().trim().length === 0) {
        this.changeableContent = false;
      }
    },
    showChangeableContent(type) {

      if (type === null) {
        this.changeableContent = false;
      } else {

        if (type.type === 'symbolPreview') {

          if (!this.quickViewSymbols.includes(type.symbol)) {

            this.quickViewSymbols.push(type.symbol)
          }
          this.quickViewSymbolDisplay = type.symbol;
        }
        this.changeableContent = true;
        this.changeableContentSettings = type;
        this.changeableContentKey++;
      }
    },
    toastMessage(message) {

      this.appToastMessage = message;
      this.$refs.appToastMessage.show(() => {

        this.appToastMessage = null;
      });
    },
    locationIncludes(inc) {

      return window.location.host.includes(inc)
    },
    setLogoWidth() {

      if (location.host.includes('ibi')) {
        return { width: '81px' }
      } else {
        return { width: '90px' }
      }
    },
    setLogo() {
      return require(`./assets/gfx/logos/${this.logoSrc}`)
    },
    async changeLang(selectedLanguage, isBanner = false) {

      if (isBanner) {
        await UserService.saveUserSettings({
          systemLanguage: selectedLanguage,
          newsLanguages: selectedLanguage,
        }, 'languages');

        eventBus.emit('changeUiLanguage', selectedLanguage)
      }


      return new Promise(resolve => {
        UserService.updateSystemLanguage(selectedLanguage);

        setTimeout(() => {
          this.$.appContext.app.config.globalProperties.systemLanguage = selectedLanguage;

          axios.defaults.headers.common['Accept-Language'] = selectedLanguage;

          this.$.appContext.app.config.globalProperties.uiDirection = (selectedLanguage === 'he' || selectedLanguage === 'ar') ? 'rtl' : 'ltr';
          this.$.appContext.app.config.globalProperties.dateFormatLocale = (selectedLanguage === 'he' || selectedLanguage === 'ar') ? 'he-IL' : 'en-US';
          const dictionary = require(`./dictionary/${selectedLanguage}`);
          this.$.appContext.app.config.globalProperties.dictionary = dictionary.default;

          if (this.$.appContext.app.config.globalProperties.uiDirection === 'rtl') {
            document.body.classList.add('rtl');
            document.documentElement.style.setProperty('--dir', 'rtl')
          } else {

            document.body.classList.remove('rtl');
            document.documentElement.style.setProperty('--dir', 'ltr')
          }

          this.globalKey++;
          this.showLanguageMenu = false;

          return resolve(true);
        }, 5);
      });
    },
    async toggleNotifications() {
      if (!this.notificationsEnabled) {
        await this.requestNotificationPermission();
      } else {

      }
    },
    async requestNotificationPermission() {

      // Notification.requestPermission().then(res => {
      // })
      // const permission = await window.;
      // this.notificationsEnabled = permission === 'granted';
    },
    clickEvent(name) {
      try {
        mixpanel.track('user:pageClick', { client: window.location.host, name });
      } catch (e) {

      }

    },
    contactUsSent() {
      this.showContactUs = false;

      try {
        mixpanel.track('user:contactUs', { client: window.location.host })
      } catch (e) {

      }

      setTimeout(() => {

        this.$refs.thankYou.style.display = 'unset'
        this.$refs.thankYou.classList.remove('hide');
        setTimeout(() => {

          this.$refs.thankYou.classList.add('hide');
          setTimeout(() => {
            this.$refs.thankYou.style.display = 'hide'
          }, 1000)
        }, 4000);
      }, 50);
    },
    scrollTopTop() {
      const container = this.$refs.topContainer;
      container.scrollTo({ top: 0 });
    },
    handleScroll() {

      const container = this.$refs.scrollContainer;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight * 0.7) {
        this.$refs.appFeed.loadNext();
      }
    },
    handleNewsScroll() {
      const container = this.$refs.scrollNewsContainer;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
        this.$refs.newsFeed.loadNext();
      }
    },
    handleScrollMainContainer() {
      const container = this.$refs.mainViewContainer;
      if (container.scrollTop + container.clientHeight >= (container.scrollHeight - 50)) {
        eventBus.emit('mainViewScrolledToBottom')
      }
    },
    getStoredWatchlist() {

      const storedWl = localStorage.getItem('wl');
      if (!storedWl) return [];

      return JSON.parse(storedWl);
    },
    handlePreMarketPrice(priceUpdate) {
      this.prices.updatePrice('preMarketPrices', {
        symbol: priceUpdate.symbol,
        price: priceUpdate.data?.price || null,
        changeP: priceUpdate.data?.changeP || null,
        volume: priceUpdate.data?.volume || null,
      });
    },
    handlePostMarketPrice(priceUpdate) {
      this.prices.updatePrice('postMarketPrices', {
        symbol: priceUpdate.symbol,
        price: priceUpdate.data?.price || null,
        changeP: priceUpdate.data?.changeP || null,
        volume: priceUpdate.data?.volume || null,
      });
    },
    handlePriceUpdate(priceUpdate) {

      this.prices.updatePrice('prices', {
        symbol: priceUpdate.symbol,
        price: priceUpdate.data.price,
        changeP: priceUpdate.data.changeP,
        marketCap: priceUpdate.data.marketCap,
        dayHigh: priceUpdate.data.dayHigh,
        dayLow: priceUpdate.data.dayLow,
        yearHigh: priceUpdate.data.yearHigh,
        yearLow: priceUpdate.data.yearLow,
        volume: priceUpdate.data.volume,
        eps: priceUpdate.data.eps,
        pe: priceUpdate.data.pe,
        sharesOutstanding: priceUpdate.data.sharesOutstanding,
        avgVolume: priceUpdate.data.avgVolume,
        priceAvg50: priceUpdate.data.priceAvg50,
        priceAvg200: priceUpdate.data.priceAvg200,
      });
    },
    async acceptedTermsInit() {
      this.acceptedTerms = true;
      await this.pingUser();
    },
    topLoaded(symbols) {
      this.socket.joinSocketRooms(symbols, 'topTen')
    },
    joinFilteredFeed(feedId) {

      this.socket.joinSocketRooms(feedId, 'ff')
    },
    feedLoaded(symbols) {

      this.symbolsInView = symbols;
      this.socket.joinSocketRooms(this.symbolsInView)
    },
    handleSocketConnected() {

      this.socket.joinSocketRooms(this.symbolsInView);
    },
    handleSocketClosed() {

    },
    findInTags(tags, tag) {

      return tags.map(tag => tag.toLowerCase().trim()).includes(tag);
    },
    checkIsBreaking(message) {

      if (message.symbols.find(symbol => symbol.symbol === 'SPY')) {

        return this.findInTags(message.tags, 'econ #s') || this.findInTags(message.tags, 'macro economic events')
      }

      return message.sourceName === 'MarketAlerts' && this.findInTags(message.tags, 'breaking');
    },
    async browserNotification(notificationData) {
      let symbolsList = notificationData.symbols.map(symbol => symbol.symbol || symbol);
      const watchlist = useWatchlist();

      if (!watchlist.premiumWatchlist?.some(symbol => symbolsList.includes(symbol.symbol))) return;

      let body = (this.systemLanguage === 'he' && notificationData.languages?.he
        ? notificationData.languages?.he
        : notificationData.title);

      if (body.trim().length === 0) return;

      if (notificationData.symbols && notificationData.symbols.length < 4) {
        body = `${symbolsList.join(', ')}: ${body}`;
      }

      body = '\u200f' + body;

      // Check for breaking notification first
      if (notificationData.isbreaking || this.checkIsBreaking(notificationData)) {
        return;
      }

      // Check permission first
      if (Notification.permission !== 'granted') {
        console.log('Notification permission not granted');
        return;
      }

      // Play sound if needed
      try {
        const hasSoundNotification = watchlist?.premiumWatchlist?.some(
          symbol => symbolsList.includes(symbol.symbol) && symbol.soundNotification
        );
        if (hasSoundNotification) {
          this.playNotificationAlert();
        }
      } catch (e) {
        console.error('Sound notification error:', e);
      }

      // Create notification using native API for better control
      try {
        const notification = new Notification(
          this.systemLanguage === 'he' ? 'הודעת EZtrade חדשה' : 'New EZtrade notification',
          {
            body,
            dir: 'auto',
            lang: this.systemLanguage,
            tag: `notification-${Date.now()}`, // Unique tag to prevent duplicates
            requireInteraction: false,
            silent: true // Prevent double sound
          }
        );

        notification.onclick = () => {
          window.focus();
          notification.close();
        };

        // Auto-close after 10 seconds
        setTimeout(() => {
          notification.close();
        }, 10000);

      } catch (e) {
        console.error('Failed to create notification:', e);
      }
    },

    async browserNotificationBreaking(notificationData) {

      const BREAKING_PHRASES = [
  "fed","federal reserve","powell","fomc","rate cut","rate hike","policy",
  "interest rates","cook","brainard","bostic","logan","goolsbee","hammack","schmid",

  "trump","tariff","tariffs","sanctions","executive order","chips act",
  "critical minerals","intel stake","trade deal","us-china","white house",
  "treasury secretary",

  "cpi","pce","nonfarm payrolls","nfp","jobless claims","durable goods",
  "pmi","ism","housing starts","home sales","existing home sales",
  "new home sales","yield curve","dxy","fitch","moody","s&p ratings",
  "core inflation",

  "s&p 500 inclusion","s&p 500 removal","added to s&p 500",
  "removed from s&p 500","dow jones","nasdaq 100","index change","rebalancing",

  "apple","microsoft","nvidia","tesla","alphabet","google","amazon","meta",
  "intel","ibm","amd","broadcom","qualcomm",

  "acquire","buy","purchase","merger","merge","stake","deal","spectrum",
  "licenses","transaction","rights issue","investment","takeover","$ billion","trillion",

  "bitcoin","ethereum","crypto","sec approves",

  "doj","sec","ftc","antitrust","investigate","investigation","probe","lawsuit",
  "criminal referral","data breach","cybersecurity","sues",

  "down","falls","drops","surges","spikes","tumbles","extends decline",
  "extends losses","short sellers","index","futures","below","above","yields",

  "profit","revenue","earnings","estimates","forecast","guidance","outlook",
  "miss","beat","margin",

  "pboc","government","restrictions","ban","banned","sanctions","tariffs",

  "acquisition","offering","equity offering","ipo","buyback","strategic review",

  "trial","clinical trial","phase 1","phase 2","phase 3","study","treatment",
  "fda","approval","data","results","efficacy","safety"
];

  const hasBreakingPhrases = BREAKING_PHRASES.some(p => notificationData.title.toLowerCase().includes(p))

  if (!hasBreakingPhrases) return;
      if (!(notificationData.isbreaking || notificationData.isBreaking) ||
        notificationData.tags.includes('wiim')) {
        return;
      }

      let symbolsList = notificationData.symbols.map(symbol => symbol.symbol);
      let body = (this.systemLanguage === 'he' && notificationData.languages?.he
        ? notificationData.languages?.he
        : notificationData.title);

      if (body.trim().length === 0) return;

      if (notificationData.symbols && notificationData.symbols.length < 4) {
        body = `${symbolsList.join(', ')}: ${body}`;
      }

      body = '\u200f' + body;

      // Check permission first
      if (Notification.permission !== 'granted') {
        console.log('Notification permission not granted');
        return;
      }

      // Play breaking sound
      this.playBreakingAlertSound();

      // Create notification using native API
      try {
        const notification = new Notification(
          this.systemLanguage === 'he' ? 'הודעת EZtrade חדשה' : 'New EZtrade notification',
          {
            body,
            dir: 'auto',
            lang: this.systemLanguage,
            tag: `breaking-${Date.now()}`, // Unique tag to prevent duplicates
            requireInteraction: false,
            silent: true // Prevent double sound since we play our own
          }
        );

        notification.onclick = () => {
          window.focus();
          notification.close();
        };

        // Auto-close after 10 seconds
        setTimeout(() => {
          notification.close();
        }, 10000);

      } catch (e) {
        console.error('Failed to create breaking notification:', e);
      }
    },
    navigateEvent(data) {

      if (data.type === 'feed') {

        if (data.value === 'sector') {

          const isFeedSeen = window.getComputedStyle(this.$refs.scrollContainer).display;
          this.feedType = 'sector';
          this.feedSymbols = data.symbol;
          if (isFeedSeen === 'none') {
            this.$router.push(`/feed/sector/${data.symbol}`);
            this.$router.go(1);
          }
          // this.globalKey++;
          // this.$refs.appFeed.loadFeed(true);
          // this.$refs.appFeed.feedKey++;

        }
      }
    },
    openSearchPanel() {

      this.showSearchBar = true;
    },
    cloeSearchPanel() {

      this.showSearchBar = false;
    },
    themeChange(theme) {
      if (theme === 'darkMode') {
        document.documentElement.setAttribute('data-theme', 'dark')
      } else {
        // document.documentElement.removeAttribute('data-theme', 'dark')
        document.documentElement.setAttribute('data-theme', 'light')
      }
    },

    async pingUser() {

      try {
        const pingResult = await UserService.pingUser();
        let { watchList, settings, acceptedTerms, systemLangDefault, terms, systemTheme, isFirstLogin } = pingResult;
        this.isFirstLogin = isFirstLogin;


        this.trialEndedUser = {
          specialOffer: pingResult.specialOffer,
          status: pingResult.trialEnded,
          userId: pingResult.userId,
          email: pingResult.email,
          systemLanguage: pingResult.systemLanguage
        }

        this.termsContent = terms;

        if (settings) {
          settings = JSON.parse(settings);

          await this.changeLang(systemLangDefault ? systemLangDefault : 'en')

          this.$.appContext.app.config.globalProperties.newsLanguages = settings.newsLanguages;
          this.$.appContext.app.config.globalProperties.systemLanguage = systemLangDefault;
          this.$.appContext.app.config.globalProperties.uiDirection = systemLangDefault === 'he' ? 'rtl' : 'ltr'; //settings.defaultDir;
          this.$.appContext.app.config.globalProperties.dateFormatLocale = systemLangDefault === 'he' ? 'he-IL' : 'en-US';


          this.$.appContext.app.config.globalProperties.systemTheme = systemTheme || 'darkTheme';
          this.themeChange(systemTheme);
          if (systemLangDefault === 'he') {
            document.body.classList.add('rtl');
            document.documentElement.style.setProperty('--dir', 'rtl')
          } else {
            document.body.classList.add('rtl');
            document.documentElement.style.setProperty('--dir', 'ltr')
          }


          if (settings.favicon) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.head.appendChild(link);
            }
            link.href = settings.favicon;
          }

          for (let k in settings.style) {
            if (k !== 'dir') {

              // document.documentElement.style.setProperty(`--${k}`, settings.style[k].replace(';', ''));
            }
          }

          if (settings.logo && settings.showLogo) this.logoSrc = settings.logo;
        }


        // this.globalKey++;
        this.userPingged = true;
        this.acceptedTerms = acceptedTerms;

        this.$nextTick(() => {

          if (location.host.includes('ibi.ma')) {
            document.querySelector('.languageClick').style.padding = '5px';
          }
        });

        this.watchList = watchList;
        this.$.appContext.app.config.globalProperties.globalWatchlist = this.watchlist;

        useWatchlist().updateWatchlist(watchList);

        const watchlistArray = Array.from(new Set(...[useWatchlist().watchlist]));
        useWatchlist().$subscribe((mutation, state) => {

          this.$.appContext.app.config.globalProperties.globalWatchlist = state;
          this.socket.updateNotificationRooms();
        });

        this.globalKey++;

      } catch (e) {


        console.log('Error!', e)

        if (e.response) {
          if (e.response.status === 307) {
            if (e.response.data.locked) {
              this.locked = true;
            } else if (e.response.data.prmLock) {

              this.prmLock = true;
            }
          } else {
            if (e.response.data.error.userStatus) {

              const userStatus = e.response.data.error.userStatus;
              if (userStatus === 'TRIAL_ENDED') {
                this.trialEnded = true;
                this.trialEndedUser = e.response.data.error.user;
              }
            }
          }
          return;
        } else {
        }
      } finally {
        this.showPremiumLogin = true;
      }

    },
    playNotificationAlert() {

      if (!this.soundsOn) return;
      this.$refs.alertSound.play()
        .then(() => {

        }).catch(e => console.log(e))
    },
    playBreakingAlertSound() {
      if (!this.soundsOn) return;
      this.$refs.breakingAlertSound.play()
        .then(() => {

        }).catch(e => console.log(e))
    },
    startResize() {
      this.resizing = true;
      window.addEventListener('mousemove', this.resize);
      window.addEventListener('mouseup', this.stopResize);
    },
    resize(event) {
      if (this.resizing) {
        this.toggleUserSelect(false);
        const deltaX = this.uiDirection === 'rtl' ? event.clientX : window.innerWidth - event.clientX;
        this.changeableContentWidth = Math.min(Math.max(350, deltaX), window.innerWidth * 0.679); // Limit minimum width
      }
    },
    stopResize() {
      this.resizing = false;
      this.toggleUserSelect(true);
      window.removeEventListener('mousemove', this.resize);
      window.removeEventListener('mouseup', this.stopResize);
    },
    toggleUserSelect(allowSelect) {
      document.body.style.userSelect = allowSelect ? 'auto' : 'none';
    },
  },
  async beforeMount() {


    await this.pingUser();

    this.storedWatchlist = this.getStoredWatchlist()

    if (this.$route.name === 'Macro') {

      this.refName = 'newsFeed';
      this.feedType = 'news'

    } else if (this.$route.name === 'Macro') {
      this.refName = 'appFeed';
      this.feedType = 'equity';

    } else if (this.$route.name === 'SectorFeed') {
      this.refName = 'appFeed';
      this.feedType = 'sector';

    } else if (this.$route.name === 'FilteredFeed') {
      this.refName = 'mainView';
      this.feedType = 'filteredFeed';
    } else {
      this.refName = 'mainView';
      this.feedType = 'neutral'
    }
  },
  created() {

  },
  beforeUnmount() {

    eventBus.off('openFeedWindow', this.openFeedWindow);
    eventBus.off('readNotification', this.readNotification);
    eventBus.off('themeChange', this.themeChange);
    eventBus.off('priceUpdate', this.handlePriceUpdate);
    eventBus.off('preMarketPrice', this.handlePreMarketPrice);
    eventBus.off('postMarketPrice', this.handlePostMarketPrice);
    eventBus.off('socketConnected', this.handleSocketConnected);
    eventBus.off('socketClosed', this.handleSocketClosed);
    eventBus.off('newEquityNotification', this.browserNotification);
    eventBus.off('newNewsNotification', this.browserNotificationBreaking);
    eventBus.off('navigate', this.navigateEvent);
    eventBus.off('changeUiLanguage', this.navigateEvent);
    eventBus.off('closeSearchPanel', this.cloeSearchPanel);
    eventBus.off('openSearchPanel', this.openSearchPanel);
    eventBus.off('toastMessage', this.toastMessage);
    eventBus.off('showChangeableContent', this.showChangeableContent);
    eventBus.off('chartWindow', this.openChartWindow);
    eventBus.off('floatingSymbolsList', this.openFloatingSymbolsList);
    eventBus.off('soundsToggle', this.toggleSounds);

    window.removeEventListener('hashchange', this.handleHashChange);

  },
  async mounted() {


    const newYorkTime = useNewYorkTime();
    newYorkTime.getNyTime();

    this.soundsOn = localStorage.getItem('soundsOn') === 'true' || localStorage.getItem('soundsOn') === null;
    eventBus.on('floatingSymbolsList', this.openFloatingSymbolsList);
    eventBus.on('openFeedWindow', this.openFeedWindow);
    eventBus.on('chartWindow', this.openChartWindow);
    eventBus.on('readNotification', this.readNotification);
    eventBus.on('showChangeableContent', this.showChangeableContent);
    eventBus.on('themeChange', this.themeChange);
    eventBus.on('newEquityNotification', this.browserNotification);
    eventBus.on('newNewsNotification', this.browserNotificationBreaking);
    eventBus.on('socketConnected', this.handleSocketConnected);
    eventBus.on('priceUpdate', this.handlePriceUpdate);
    eventBus.on('preMarketPrice', this.handlePreMarketPrice);
    eventBus.on('postMarketPrice', this.handlePostMarketPrice);
    eventBus.on('navigate', this.navigateEvent);
    eventBus.on('changeUiLanguage', this.changeLang);
    eventBus.on('closeSearchPanel', this.cloeSearchPanel);
    eventBus.on('openSearchPanel', this.openSearchPanel);
    eventBus.on('toastMessage', this.toastMessage);
    eventBus.on('soundsToggle', this.toggleSounds);

    window.addEventListener('hashchange', this.handleHashChange);


    this.$.appContext.app.config.socket = Socket();
    this.socket = this.$.appContext.app.config.socket;
    mixpanel.track('user:view', { client: window.location.host })

    setTimeout(() => {
      this.socket.updateNotificationRooms();
    }, 1000)
  }
}
</script>

<style lang="scss">
@import "./assets/style/vars";
@import "./assets/style/general";

#desktopLinks {
  display: flex;
}

.resizable {
  flex: 1 0 auto;
  width: 520px;

  @media(max-width: 1430px) {
    width: 420px;
  }

  @media(max-width: 660px) {
    display: none;
  }
}

#appWrapper {
  display: flex;
  flex-direction: column;
}


#navBar {
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 12;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
  padding: .25rem 1rem;
  background: var(--notficationBorderColor);
  transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);

  .navLinks {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &.p {
    position: fixed;
    left: 0;
    top: 0;
    flex-direction: row;
    align-items: flex-start;
    border-bottom: 3px solid var(--notficationBorderColor);
    width: 100%;
    padding: .25rem;
    box-sizing: content-box;
    overflow: hidden;
    white-space: nowrap;

    @media(max-width: 660px) {
      width: 100%;
      height: 26px;
    }

    &[dir="rtl"] {
      right: 0;
      left: unset;
      border-right: unset;
      border-left: 2px solid var(--tableBorderColor);
    }

    a {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      gap: 5px;

      span {
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: space-between;

      }
    }
  }
}

.newTag {
  background: var(--lightYellow);
  color: var(--bgColor);
  font-weight: 500;
  font-size: 11px;
  border-radius: 4px;
  padding: 0 2px;
  width: fit-content;
  display: inline-flex;

  @media(max-width: 660px) {
    font-size: 16px;
    padding: 2px;
  }
}

.resize-handle {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 12px;
  cursor: ew-resize;
  background-color: black;
  z-index: 11;

  &[dir="rtl"] {
    left: unset;
    right: 0;
  }

  @media(max-width: 660px) {
    display: none;
  }

  &:hover {
    background-color: #333333;
  }

  .iconContainer {
    position: relative;
    width: 100%;
    height: 100%;

    i {
      color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
    }
  }
}

.navLink {
  padding: 5px 1rem;
  font-size: 18px;
  text-decoration: none;
  color: var(--navBarLinkColor);
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;

  &.closeLink {
    padding: 1rem 1rem;
  }

  i {
    font-size: 18px;
  }

  @media(max-width: 660px) {
    border-radius: 0;
  }

  &:hover {
    background: var(--highlightColorOpacity);
    color: var(--highlightColor);
  }
}


.navLink.router-link-active:not(.notActive) {
  color: var(--bgColor);
  background: var(--highlightColor);

  span {
    font-weight: bolder;
  }
}

.navLink.desktop {
  font-size: 14px;
  padding: 3px 8px;
}


.feed {
  display: flex;
  align-items: flex-start;
  background: var(--bgColor);
  transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);
  margin-top: 35px;
  background: var(--tableBorderColor);
  height: 99.9vh;
  overflow: hidden;

  @media (max-width: 1460px) {
    height: 94.9vh;
  }

  @media(max-width: 660px) {
    padding-left: 0;
    padding-top: 0;
    height: unset;
    overflow: unset;
  }

  &[dir="rtl"] {
    padding-left: unset;

    @media(max-width: 660px) {
      padding-right: 0;
    }
  }

  &.feedMenuOn {
    overflow-x: hidden;
  }


  @media(max-width: 660px) {
    gap: 0;
  }

  #view {
    overflow-y: auto;
    height: calc(100vh - 5px);
    background: var(--feedBg);
    width: 100%;

    @media(max-width: 660px) {
      display: none;
    }

    &.p {
      transition: all .2s ease-in;

      &.contract {
        height: 50vh;
      }
    }
  }

  #macroNewsFeed {
    //height: calc(100vh - 52px);
    overflow-y: auto;
    background: var(--bgColor);
    //width: 70%;
    width: 100%;
    margin: 0 5px 0 0;
    height: calc(100vh - 25px);

    &.p {
      margin: 0px 2px 0 0;
    }

    @media(max-width: 660px) {
      width: 100%;
      margin: 0;
    }
  }

  #sidePane {
    //overflow-y: auto;
    overflow: hidden;
    height: calc(100vh - 52px);
    width: 30%;
    background: var(--bgColor);

    @media(max-width: 660px) {
      display: none;
    }
  }
}

#byMarketBit {
  font-weight: 600;
  color: #42b983;
  background: black;
  padding: 5px 10px;
  border-radius: 8px;
  direction: ltr;
  display: flex;
  align-items: center;
  gap: 5px;

  img {
    width: 22px;
  }
}


.desktop {
  @media screen and (max-width: 660px) {
    display: none !important;
  }
}

.mobile {
  @media (min-width: 660px) {
    display: none;
  }
}

#mobileMenu {
  padding: 10px;
  margin: -10px;
  width: 95%;
}

.whiteMobilMenu {
  color: white;
}

#mobileNavBar {
  position: fixed;
  right: 0;
  border-left: 2px solid var(--notficationBorderColor);
  box-shadow: 0 5px 25px 0 rgba(15, 15, 15, .15);
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--navBarBgColor);
  z-index: 99999999999999;
  overflow-y: auto;

  a {
    border-bottom: 1px solid var(--notficationBorderColor);
    padding: 1rem;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}

.slide-fade-enter-active {
  transition: all 0.25s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(100%);
}

.contactButton {
  color: var(--highlightColor);
  background: var(--highlightColorOpacity);
  display: flex;
  align-items: center;
  gap: 5px;
}

#contactUsSent {
  position: fixed;
  transition: all .4s ease-in;
  left: 50%;
  top: 2rem;
  z-index: 9;
  background: var(--bgColor);
  padding: 1rem;
  border-radius: 8px;
  transform: translateX(-50%);
  box-shadow: 0 5px 25px 0 var(--highlightColorOpacity), 0 5px 55px rgba(0, 0, 0, 0.2), 0 5px 55px 10px var(--highlightColorOpacity);
  font-size: 18px;
  font-weight: 500;
  text-align: center;

  span {
    display: block;
    margin-bottom: -15px;
    font-size: 20px;
    font-weight: 600;
  }
}

#contactUsSent.hide {
  transform: translate(-50%, 2.5rem);
  opacity: 0;
}

.terms {
  margin-right: auto;
}

.notificationsToggle {
  background: var(--highlightColor);
  color: white;
  padding: 2px 8px;
  border-radius: 8px;
  margin: -5px;
}


.expl {
  background: var(--dailyBriefBgColor);
  padding: $smallGap;
  margin: 5px;
  border-radius: 8px;
  color: var(--highlightColor);
  font-weight: 500;
}

.expl.alert {
  color: white;
  font-size: 18px;
}

.portfolioLink {
  background: var(--highlightColor);
  color: white;
  display: block;
  width: fit-content;
  text-align: center;
  margin: 25px auto;
  padding: 5px 10px;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
}

#systemUpdate {
  text-align: center;
  padding-top: 2rem;
  color: black;
}

.languageClick {
  position: relative;
  flex: 0 0 fit-content;

  &:hover {
    color: black;

    div {
      color: black;
    }
  }

  .langList {

    p {
      font-weight: 600;
      margin: 0;
      padding: 5px 10px 5px;
      border-bottom: 1px solid var(--notficationBorderColor);
    }

    div {
      margin: 0;
      padding: 5px 10px;

      &:hover {
        background: var(--tableHoverColor);
      }
    }


    div.select {
      color: var(--highlightColor);
    }

    overflow: hidden;
    position: absolute;
    z-index: 9999;
    background: var(--bgColor);
    width: 220px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.35);
    transform: translateY(10px);
  }
}

#feedTitleReturn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 auto;

  #returnToPortfolio {
    font-size: 12px;
    cursor: pointer;
  }
}

#searchSymbolButton {
  font-weight: bolder;
  border-radius: 8px;
  background: var(--highlightColor);
  color: var(--bgColor);
  cursor: pointer;
  padding: 5px 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 1px var(--highlightColorOpacity);
  flex: 0 0 fit-content;

  @media(max-width: 768px) {
    margin-top: -3px;
  }
}

#proMobileMenu {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dynamicContent {
  transition: all .2s ease-in;
  //height: 50%;
}

.changeableContent {
  transition: all .2s ease-in;
  border-top: 5px solid var(--notficationBorderColor);
  position: fixed;
  right: 0;
  transform: translateX(110%);
  height: 100%;
  z-index: 99999;
  border-left: 2px solid var(--notficationBorderColor);
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.3);
  background: var(--bgColor);
  padding-top: 32px;

  @media(max-width: 660px) {
    width: 100%;
    box-sizing: border-box;
    padding-top: 0;
    padding-bottom: 70px;
  }

  &[dir="rtl"] {
    border-left: unset;
    border-right: 2px solid var(--notficationBorderColor);
    transform: translateX(-110%);
    right: unset;
    left: 0;
  }

  .changeableContentClose {
    z-index: 12;
    cursor: pointer;
    padding: 5px;
    border-bottom: 1px solid var(--notficationBorderColor);
    position: fixed;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    left: 0;
    font-weight: 700;
    background: var(--lightYellow);
    color: var(--bgColor);
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media(max-width: 660px) {
      top: unset;
      position: fixed;
      bottom: 43px;

      left: 0;
      width: 100%;
      box-sizing: border-box;
      border-top: 1px solid var(--notficationBorderColor);
    }
  }

  .content {
    overflow-y: auto;
    height: calc(90%);
    width: calc(100% - 5px);
    margin-left: 10px;

    &[dir="rtl"] {

      margin-right: 10px;
    }

    @media(max-width: 660px) {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      box-sizing: border-box;
    }
  }

  &.show {
    transform: translateX(0);
    overflow-y: auto;
  }
}

#breakingFeedFloat {
  position: fixed;
  left: 520px;
  width: 420px;
  border-left: 1px solid var(--notficationBorderColor);
  border-right: 1px solid var(--red);
  bottom: 0;
  z-index: 11;
  box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.45), 15px 0 15px 0 var(--opacityRed);
  background: var(--bgColor);

  height: 96.3vh;
  overflow: scroll;

  @media (max-width: 1460px) {
    height: 94.54vh;
  }

  @media(max-width: 660px) {
    height: unset;
    overflow: unset;
  }
}

#notificationReader {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  width: 50%;
  height: 100%;
  background: var(--bgColor);
  z-index: 999;
  border-left: 1px solid var(--notficationBorderColor);
  border-right: 1px solid var(--notficationBorderColor);
  box-shadow: 0 0 435px 10px rgba(0, 0, 0, .8);
}

.symbolsQuickViewTabs {
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  flex-wrap: nowrap;
  padding-top: 5px;
  border-bottom: 2px solid var(--notficationBorderColor);

  .quickViewSymbol {
    padding: 5px 10px;
    cursor: pointer;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    align-items: center;
    gap: 10px;

    i {
      padding: 5px;
      margin: -5px;
    }

    &:hover {
      background: var(--tableHoverColor);
    }

    &.active {
      background: var(--accentBackground);
    }
  }
}

#feedToggle {
  position: absolute;
  top: 50%;
  z-index: 99;
  background: var(--notficationBorderColor);
  left: 0;
}

#minimizedTabs {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  overflow-x: auto;
  flex-wrap: nowrap;

  .minimizedTab {
    background: var(--accentBackground);
    padding: 5px 10px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.breakingNewsItem {
  background: var(--opacityRed) !important;
  color: var(--red) !important;
}

.toggleResize {
  position: relative;
  width: 20px;
  height: 100%;
  flex: 1 0 16px;
  cursor: pointer;
  background: var(--tableHoverColor);
  border-left: 1px solid var(--notficationBorderColor);
  border-right: 1px solid var(--notficationBorderColor);
  background: var(--notficationBorderColor);
}

#mainWrapper {
  @media (max-width: 660px) {
    height: 100vh;
    overflow: hidden;
  }
}


.green {
  background: var(--opacityGreen) !important;
  color: var(--green);
  text-align: center;
  unicode-bidi: plaintext;
  z-index: 1;
}

.red {
  background: var(--opacityRed) !important;
  color: var(--red);
  text-align: center;
  unicode-bidi: plaintext;
  z-index: 1;
}

.neutral {
  background: rgba(0, 0, 0, 0.2) !important;
  color: #aaa;
  text-align: center;
  unicode-bidi: plaintext;
  z-index: 1;
}

[data-theme="light"] {
  .neutral {
    background: rgba(0, 0, 0, 0.02) !important;
  }
}

.inCellHeight {
  height: 21px;
}

.soundsToggle {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--lightYellow);
  width: 26px;
  height: 24px;
  margin-top: 1px;
  border-radius: 8px;
  color: var(--bgColor);
  margin: 1px 5px 0;
}
</style>
